import APIClient from '@/shared/http/clients/api'

const resourceName = 'gedPastaChecklistTipo'
const APIBusinessCommon = process.env.APIBaseURLBusinessCommon

const GetAll = (folderID, data = {}, config = {}) => APIClient.get(`${APIBusinessCommon}/${resourceName}/pasta/${folderID}`, data, config)
const GetChecklistStatus = (folderID, data = {}, config = {}) => APIClient.get(`${APIBusinessCommon}/${resourceName}/pasta/${folderID}/status`, data, config)
const Update = (data = {}, config = {}) => APIClient.put(`${APIBusinessCommon}/${resourceName}`, data, config)

const GedFolderChecklistTypeRepository = {
  GetAll,
  GetChecklistStatus,
  Update
}

export default GedFolderChecklistTypeRepository



// WEBPACK FOOTER //
// ./src/shared/http/repositories/business/gedfolderchecklisttype.js